module.exports = __webpack_public_path__ + "static/media/nb_akademie_light_italic-webfont.035d68da.ttf";